import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sub-nav" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "sub-header"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "uk-icon-angle-up uk-margin-small-left uk-text-bold"
}
const _hoisted_9 = {
  key: 1,
  class: "uk-icon-angle-down uk-margin-small-left uk-text-bold"
}
const _hoisted_10 = { class: "sublinks-inner" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "sub-link-text" }
const _hoisted_13 = { class: "logo" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "logo-pad" }, null, -1)
const _hoisted_15 = { class: "logo-img" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SlideUpDown = _resolveComponent("SlideUpDown")!
  const _component_CompanyLogo = _resolveComponent("CompanyLogo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        innerHTML: _ctx.nav.title
      }, null, 8, _hoisted_3),
      (_ctx.nav.subtitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.nav.subtitle) + " plan ", 1))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.title
      }, [
        (item.type === 'link')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['link link-inner', { selected: item.selected }]),
              onClick: ($event: any) => (_ctx.toggleClose(item, idx))
            }, [
              _createElementVNode("span", {
                innerHTML: item.title
              }, null, 8, _hoisted_6),
              (item.hasSubLinks)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    (!item.closed)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                      : (_openBlock(), _createElementBlock("i", _hoisted_9))
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_5))
          : (item.type === 'sublinks')
            ? (_openBlock(), _createBlock(_component_SlideUpDown, {
                key: 1,
                active: !item.closed,
                duration: 500,
                class: "sublinks"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.links, (sublink) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: sublink.id,
                        class: _normalizeClass([
                            'link sublinks-link',
                            { selected: sublink.selected },
                        ]),
                        onClick: ($event: any) => (_ctx.toggleClose(sublink, idx))
                      }, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(sublink.title), 1)
                      ], 10, _hoisted_11))
                    }), 128))
                  ])
                ], undefined, true),
                _: 2
              }, 1032, ["active"]))
            : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_CompanyLogo, { url: _ctx.logoImg }, null, 8, ["url"])
      ])
    ])
  ]))
}